import React, { Component, Fragment, cloneElement } from "react";
import NewDropdownNested from "./NewDropdownNested";
import { arrowTopDropdown } from "../svgIcons";
import serverClientUtil from "../../../../utils/serverClientUtil";

class NewDropdown extends Component {
  state = {
    activeNestedTitle: '',
  };

  modifyChildren = (child) => {
    const props = {
      className: child.props.className,
    };

    return cloneElement(child, props);
  };

  handleOverNestedMenu = (e) => {
    this.setState({ activeNestedTitle: e.currentTarget.name });
  };

  handleReleseNestedMenu = () => {
    this.setState({ activeNestedTitle: '' });
  };

  render() {
    const {
      handleOnHoverBtn,
      dataList,
      aboveOtherSitesButton = "",
      aboveServicesButton = "",
      aboveUserBtn = "",
      children = {},
      infoSession,
      stylePosition = "-25px",
    } = this.props;
    const { props = {} } = children;
    const { activeNestedTitle } = this.state;

    return (
      <div
        className={`dropDownContainer ${
          aboveUserBtn ? "dropDownContainerUserBtn" : ""
        }`}
        style={{ right: stylePosition }}
        onMouseEnter={() => handleOnHoverBtn(true)}
        onMouseLeave={() => handleOnHoverBtn(false)}
      >
        <div>
          <div
            style={{
              height: "10px",
              background:
                aboveServicesButton || aboveOtherSitesButton
                  ? "#70004c"
                  : "#e10098", // TODO: Brand
            }}
          >
            {arrowTopDropdown}
          </div>
          <div className="borderRoundTop" />
        </div>
        <ul className="resetUlStyles dropdownContent">
          <Fragment>
            {props.children && props.children[0]}
            {dataList?.map(
              (
                { text, name = "", url, icon = "", items = [], label },
                index
              ) => (
                <li key={text || label}>
                  {/* // TODO: review this implementation for figma. Problem performance!! */}
                  <a
                    href={serverClientUtil.getNavUrl(url)}
                    style={{ position: "relative" }}
                    className={`${
                      items.length ? "flexBetween" : "flexStart"
                    } textIndentEfect`}
                    data-active={
                      index === 0 || index === dataList.length - 1
                        ? "activeHoverFirstChild"
                        : ""
                    }
                    onMouseEnter={(e) => this.handleOverNestedMenu(e, items)}
                    onMouseLeave={(e) => this.handleReleseNestedMenu(e, items)}
                    name={text || label || name }
                    target="_self"
                    rel="noopener noreferrer"
                  >
                    {icon}
                    {Array.isArray(items) && items.length ? (
                      <NewDropdownNested
                        dataNested={{
                          title: text || label || name,
                          activeNestedTitle,
                          links: items,
                        }}
                      />
                    ) : (
                      text || label || name
                    )}
                  </a>
                </li>
              )
            )}
            <li className={"closeSessionBtn"}>
              {props.children && props.children[1]}
            </li>
          </Fragment>
        </ul>
        {/* // TODO: Dinamic brand */}
        <div
          className="borderRoundBottom"
          style={{
            background:
              infoSession && infoSession.hasActiveSession
                ? "#F5F5F5"
                : "#FFFFFF",
          }}
        />
      </div>
    );
  }
}

export default NewDropdown;
